import { Link } from '@mui/material';
import { Link as LinkRouter } from 'react-router-dom';

type Props = {
  value: string;
  to: string;
  cut?: number;
};
export const LinkLabel = ({ value, to, cut=7 }: Props) => (
  <LinkRouter style={{ textDecoration: 'none' }} to={to}>
    <Link>{value.slice(0, cut)} </Link>
  </LinkRouter>
);
